import type { CommonCoverNoteResponse } from '../../../types/coverNoteApi';
import type { ExtraditionMlaWizardDraft } from '../../../types/extraditionMlaCaseRequest';

/** Fill cover note gaps from wizard draft when the cover-note API omits fields. */
export function extraditionMlaDraftToCoverNoteFallback(
  draft: ExtraditionMlaWizardDraft,
  options?: { fileRef?: string; submittedDivisionName?: string },
): Partial<CommonCoverNoteResponse> {
  const documents = draft.documents
    .filter((d) => d.documentName.trim() && (d.fileName.trim() || d.skipReason.trim()))
    .map((d) => d.documentName.trim());

  return {
    fileReferenceNumber: options?.fileRef?.trim() || draft.referenceNo.trim(),
    submittedDivisionName: options?.submittedDivisionName?.trim() || draft.submittedDivisionName.trim() || '',
    fileCategory: draft.fileCategory.trim(),
    subFileCategory: draft.subFileCategoryName.trim(),
    applicableAreas: draft.applicableAreas.length ? draft.applicableAreas : null,
    description: draft.description.trim() || null,
    caseSource: draft.caseSource.trim() || null,
    urgencyLevel: draft.urgencyLevelName.trim() || null,
    deadline: draft.deadline.trim() || null,
    urgencyJustification: draft.urgencyJustification.trim() || null,
    connectedAgdFileReferenceNumber:
      draft.hasConnectedMatters === 'yes' && draft.connectedAgdFileRefAvailable
        ? draft.connectedAgdFileRef.trim() || null
        : null,
    documents,
  };
}
